module.exports = __webpack_public_path__ + "img/38.ec2087a3.webp";